import { createAsyncAction } from "reactcoregk/store/actions";
import {
  ADD_TABLE_SETTINGS,
  GET_ALL_TABLE_SETTINGS,
  GET_THEME_PREFERENCES,
  UPDATE_THEME_PREFERENCES,
} from "./actionTypes";
import { entityType } from "./module";

export const getAllTableSettingActions = createAsyncAction(
  entityType,
  GET_ALL_TABLE_SETTINGS
);
export const addTableSettingActions = createAsyncAction(
  entityType,
  ADD_TABLE_SETTINGS
);

export const getAllThemePreferencesActions = createAsyncAction(
  entityType,
  GET_THEME_PREFERENCES
);
export const updateThemePreferencesActions = createAsyncAction(
  entityType,
  UPDATE_THEME_PREFERENCES
);

export const getAllTableSettings = () => getAllTableSettingActions.request();
export const addTableSettings = (payload) =>
  addTableSettingActions.request(payload);

export const getThemePreferences = () =>
  getAllThemePreferencesActions.request();
export const toggleThemeMode = (isLight) =>
  updateThemePreferencesActions.request(isLight);
